import FixedGuidance from "./FixedGuidance";
import FloatingGuidance from "./FloatingGuidance";
class CouponGuidance {
    fixed;
    floating;
    constructor(response) {
        this.fixed = response.fixed !== undefined ? new FixedGuidance(response.fixed) : undefined;
        this.floating = response.floating !== undefined ? new FloatingGuidance(response.floating) : undefined;
    }
    print() {
        if (this.fixed !== undefined) {
            return this.fixed.print();
        }
        else if (this.floating) {
            return this.floating.print();
        }
        return "UNKNOWN";
    }
}
export default CouponGuidance;
